// Cocoonette theme — interactions JS
document.addEventListener('DOMContentLoaded', function () {

  // ── Menu hamburger ──────────────────────────────────────────
  var btn = document.querySelector('.hamburger');
  var menu = document.getElementById('mobile-menu');
  if (btn && menu) {
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      menu.setAttribute('aria-hidden', String(open));
      menu.classList.toggle('open', !open);
    });
    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        btn.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-hidden', 'true');
        menu.classList.remove('open');
      });
    });
  }

  // ── Hero carousel ───────────────────────────────────────────
  var carousel = document.querySelector('.hero-carousel');
  if (!carousel) return;

  var slides   = carousel.querySelectorAll('.hc-slide');
  var pbItems  = carousel.querySelectorAll('.hc-pb-item');
  var prevBtn  = carousel.querySelector('.hc-arrow--prev');
  var nextBtn  = carousel.querySelector('.hc-arrow--next');

  if (slides.length < 2) return;

  var current    = 0;
  var total      = slides.length;
  var speedSec   = parseInt(carousel.dataset.speed || '5', 10);
  var speed      = speedSec * 1000;
  var timer      = null;
  var leaving    = null;
  var transition = carousel.dataset.transition || 'fade';

  // Injecte la durée en CSS var pour l'animation des barres
  carousel.style.setProperty('--hc-speed', speedSec + 's');

  if (transition === 'slide') carousel.classList.add('hc-carousel--slide');

  function resetBars() {
    pbItems.forEach(function (pb) {
      pb.classList.remove('is-active');
      pb.setAttribute('aria-selected', 'false');
      var fill = pb.querySelector('.hc-pb-fill');
      if (fill) { fill.style.animation = 'none'; fill.offsetHeight; fill.style.animation = ''; }
    });
  }

  function goTo(index) {
    if (index === current) return;

    var oldSlide = slides[current];
    var newSlide = slides[index];

    if (transition === 'slide') {
      if (leaving) leaving.classList.remove('is-leaving');
      oldSlide.classList.add('is-leaving');
      leaving = oldSlide;
      setTimeout(function () {
        if (leaving) { leaving.classList.remove('is-leaving'); leaving = null; }
      }, 650);
    }

    oldSlide.classList.remove('is-active');
    current = index;
    newSlide.classList.add('is-active');

    resetBars();
    if (pbItems[current]) pbItems[current].classList.add('is-active');
  }

  function advance() { goTo((current + 1) % total); }

  function startTimer() {
    clearInterval(timer);
    timer = setInterval(advance, speed);
  }
  function stopTimer() { clearInterval(timer); }

  // Init barre active
  if (pbItems[0]) pbItems[0].classList.add('is-active');
  startTimer();

  // Pause au survol
  carousel.addEventListener('mouseenter', function () { stopTimer(); });
  carousel.addEventListener('mouseleave', function () { startTimer(); });
  carousel.addEventListener('focusin',    function () { stopTimer(); });
  carousel.addEventListener('focusout',   function () { startTimer(); });

  // Fleches
  if (prevBtn) prevBtn.addEventListener('click', function () {
    goTo((current - 1 + total) % total); stopTimer(); startTimer();
  });
  if (nextBtn) nextBtn.addEventListener('click', function () {
    goTo((current + 1) % total); stopTimer(); startTimer();
  });

  // Barres cliquables
  pbItems.forEach(function (pb) {
    pb.addEventListener('click', function () {
      goTo(parseInt(pb.dataset.index, 10)); stopTimer(); startTimer();
    });
  });

  // Swipe tactile
  var touchStartX = null;
  carousel.addEventListener('touchstart', function (e) {
    touchStartX = e.touches[0].clientX;
  }, { passive: true });
  carousel.addEventListener('touchend', function (e) {
    if (touchStartX === null) return;
    var delta = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(delta) > 50) {
      goTo(delta < 0 ? (current + 1) % total : (current - 1 + total) % total);
      stopTimer(); startTimer();
    }
    touchStartX = null;
  }, { passive: true });

});
